import type { CSSProperties } from 'react';
import type { ClassColor } from '@repo/shared-types';

/**
 * Inline style for a ClassGroup's colour tint/ink pair (design spec §2
 * decision 7, handoff README decision 2): a filled tint background with an
 * ink border/text. The eight `--class-<color>-tint` / `--class-<color>-ink`
 * custom properties live in `packages/ui/src/global.css` — this stays a
 * `var()` lookup rather than a Tailwind class name because the colour is
 * data-driven: a template-built class name (`bg-class-${color}-tint`) would
 * never survive Tailwind's static class scan.
 *
 * `color: null` is the "automatic, not resolved yet" state (a single-slot
 * class, or a class the colour-assign rule has not reached) — callers render
 * a dashed hollow square instead of calling this (see ClassListTab /
 * TimetableGridTab), so this returns `null` rather than a fallback colour.
 */
export function classColorStyle(color: ClassColor | null): CSSProperties | null {
  if (!color) return null;
  return {
    background: `var(--class-${color}-tint)`,
    borderColor: `var(--class-${color}-ink)`,
    color: `var(--class-${color}-ink)`,
  };
}
